import { useUser } from '../../../Context/useUser';
import API from '../../../Utils/api';

import styles from './EditCoachModal.module.css';
import { toast } from 'react-toastify';
import Avatar from 'react-avatar';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaSwimmer, FaCalendar, FaTrash, FaCheck } from 'react-icons/fa';

export default function EditCoachModal({ onClose, relationship }) {
    const { user } = useUser();
    const acceptCoach = async () => {
        try {
            await API.approveRelationshipById(relationship._id);
            onClose?.();
            toast.success('Coaching invitation accepted. This coach is now on your list.', {
                position: 'bottom-center'
            });
        } catch (error) {
            toast.error(error?.response?.data?.error, {
                position: 'bottom-center'
            });
        }
    };
    const rejectCoach = async () => {
        const wasPending = relationship.status === 'Pending';
        try {
            await API.deleteRelationshipById(relationship._id);
            onClose?.();
            toast.success(
                wasPending
                    ? 'Invitation removed.'
                    : 'Coach removed from your list.',
                {
                    position: 'bottom-center'
                }
            );
        } catch (error) {
            toast.error(error?.response?.data?.error, {
                position: 'bottom-center'
            });
        }
    };

    const coach = relationship.coach;

    const detailItems = [
        { icon: FaEnvelope, label: 'Email', value: coach.email, isEmail: true },
        { icon: FaPhone, label: 'Phone', value: coach.phoneNumber },
        { icon: FaSwimmer, label: 'Swimming Club', value: coach.swimmingClub },
        { icon: FaMapMarkerAlt, label: 'Location', value: coach.location }
    ].filter(item => item.value && String(item.value).trim());

    if (relationship.status === 'Pending') {
        return (
            <div className={styles.modalContent}>
                <div className={styles.coachHeader}>
                    <Avatar
                        name={`${coach.firstName || ''} ${coach.lastName || ''}`}
                        size='80'
                        round={true}
                        className={styles.avatar}
                    />
                    <div className={styles.coachInfo}>
                        <h3 className={styles.coachName}>
                            {coach.title ? `${coach.title} ` : ''}{coach.firstName} {coach.lastName}
                        </h3>
                        <span className={styles.statusBadge} data-status="pending">
                            Pending
                        </span>
                    </div>
                </div>

                <div className={styles.pendingNote}>
                    <p>Contact details are hidden until this coaching link is active.</p>
                </div>

                <div className={styles.detailsSection}>
                    <div className={styles.detailItem}>
                        <FaCalendar className={styles.detailIcon} />
                        <div>
                            <div className={styles.detailLabel}>Invited</div>
                            <div className={styles.detailValue}>
                                {new Date(relationship.createdAt).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.actions}>
                    {relationship.createdBy !== user._id && (
                        <button className={styles.primaryBtn} onClick={acceptCoach}>
                            <FaCheck />
                            <span>Accept Coach</span>
                        </button>
                    )}
                    <button className={styles.dangerBtn} onClick={rejectCoach}>
                        <FaTrash />
                        <span>Remove</span>
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.modalContent}>
            <div className={styles.coachHeader}>
                <Avatar
                    name={`${coach.firstName || ''} ${coach.lastName || ''}`}
                    size='80'
                    round={true}
                    className={styles.avatar}
                />
                <div className={styles.coachInfo}>
                    <h3 className={styles.coachName}>
                        {coach.title ? `${coach.title} ` : ''}{coach.firstName} {coach.lastName}
                    </h3>
                    <span className={styles.statusBadge} data-status="active">
                        Active
                    </span>
                </div>
            </div>

            <div className={styles.detailsSection}>
                {detailItems.map(({ icon: Icon, label, value, isEmail }) => (
                    <div key={label} className={styles.detailItem}>
                        <Icon className={styles.detailIcon} />
                        <div>
                            <div className={styles.detailLabel}>{label}</div>
                            <div className={styles.detailValue}>
                                {isEmail ? (
                                    <a href={`mailto:${value}`} className={styles.emailLink}>
                                        {value}
                                    </a>
                                ) : (
                                    value
                                )}
                            </div>
                        </div>
                    </div>
                ))}
                <div className={styles.detailItem}>
                    <FaCalendar className={styles.detailIcon} />
                    <div>
                        <div className={styles.detailLabel}>Coaching Since</div>
                        <div className={styles.detailValue}>
                            {new Date(relationship.updatedAt).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.actions}>
                <button className={styles.dangerBtn} onClick={rejectCoach}>
                    <FaTrash />
                    <span>Remove Coach</span>
                </button>
            </div>
        </div>
    );
}
